import React, { useEffect, useRef, useState } from 'react';
import "../../src/App.css";

const SliderLabels = ({ header, selected, setSelected, foundMap, addCommasToNumber, gsExpand }) => {
    const scrollContainerRef = useRef(null);
    const filteredHeader = header?.filter(h => foundMap[h.accessor] > 0);
    const [showScrollbar, setShowScrollbar] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            const container = scrollContainerRef.current;
            if (!container) return;
            
            let rowHeight = 0;
            if (container.children.length > 0) {
                const firstButton = container.children[0];
                rowHeight = firstButton.offsetHeight;
            } else {
                rowHeight = 24; 
            }
            
            const gap = 8;
            const threeRowsHeight = (rowHeight * 3) + (gap * 2);
            const contentHeight = container.scrollHeight;
            
            setShowScrollbar(contentHeight > threeRowsHeight);
            
        };
        
        const timerId = setTimeout(checkOverflow, 100);
        
        window.addEventListener('resize', checkOverflow);
        
        return () => {
            clearTimeout(timerId);
            window.removeEventListener('resize', checkOverflow);
        };
    }, [filteredHeader, gsExpand]);

    return (
        <div className="relative w-full flex items-center">
            <div 
                ref={scrollContainerRef}
                className={`
                    w-full px-4 rounded flex flex-wrap items-start gap-2 max-h-[70px] 
                    ${showScrollbar ? 'overflow-y-auto gs-scrollbar' : 'overflow-y-hidden'}
                    scroll-smooth
                `}
            >
                {filteredHeader?.map((h, i) => h.label && (
                    <button
                        key={i}
                        className={`min-w-fit text-sm px-1 first:pl-0 last:pr-0 ${gsExpand ? 'mb-[10px]' : ''}`}
                        type="button"
                        onClick={() => {
                            document.getElementById(h.accessor)?.scrollIntoView({behavior: 'smooth'});
                            setSelected(h.accessor);
                        }}
                    >
                        <span
                            className={`
                                py-1 px-3 text-sm
                                ${h.accessor === selected 
                                ? "bg-[#BC8B20] text-white" 
                                : "text-[#BC8B20] border-[1.25px] border-[#BC8B20] hover:bg-[#BC8B20]/10"
                                }
                                rounded-[13.5px] font-medium leading-[16px]
                                inline-flex items-center justify-center gap-1 transition-colors
                            `}
                        >
                            {h.label}
                            <span className="text-xs">
                                ({addCommasToNumber(foundMap[h.accessor])})
                            </span>
                        </span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default SliderLabels;